import Navbar from "../Components/Navigation/Navbar";

import React from "react";
import 'react-calendar/dist/Calendar.css';

import Register from "../Components/login/register";
import {Button, Card} from "react-bootstrap";

function RegisterPage() {

    return (<>
            <Navbar/>
            <div className="card"><h1>Register</h1>
                <Register />
            </div>
<Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
        </>
    )


}

export default RegisterPage;